import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { STATUS_META, type LeadStatus } from '../lib/leadMeta';
import { BADGE_POP } from '../lib/motion';

interface StatusBadgeProps {
  status: string;
  className?: string;
}

/** Status badge that pops when its value changes (e.g. after a bulk action). */
export function StatusBadge({ status, className }: StatusBadgeProps) {
  const meta = STATUS_META[status as LeadStatus] ?? STATUS_META.new;
  const Icon = meta.icon;

  return (
    <Badge variant="outline" className={cn('gap-1 whitespace-nowrap font-medium', meta.className, className)}>
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={status}
          className="inline-flex items-center gap-1"
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.85 }}
          transition={BADGE_POP}
        >
          <Icon className="h-3 w-3" aria-hidden="true" />
          {meta.label}
        </motion.span>
      </AnimatePresence>
    </Badge>
  );
}
